import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ReviewGrid from './components/ReviewGrid';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <HeroSection />

      <ReviewGrid />

      <section className="w-full bg-background-100 border-y border-background-200/70 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center flex flex-col items-center gap-4">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-xs md:text-sm font-medium text-primary-700">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-shield-check-line text-primary-500 text-sm"></i>
            </span>
            Güveniniz Bizim Önceliğimiz
          </span>
          <h4 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
            <a href="#reviews">Neden SaloonS?</a>
          </h4>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg leading-relaxed">
            Tüm yorumlarımız <strong>gerçek müşterilerimiz</strong> tarafından kaydedilmiştir. Her müşterimizin onayı alınarak yayınlanır. <strong>Şeffaflık</strong> ve <strong>güven</strong> temel prensibimizdir.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-4 w-full">
            <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-verified-badge-fill text-primary-500 text-lg"></i>
              </span>
              <h5 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">Doğrulanmış Yorumlar</h5>
              <p className="text-xs text-foreground-400 leading-relaxed">Her yorum gerçek müşteri deneyimidir</p>
            </div>
            <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-user-star-line text-primary-500 text-lg"></i>
              </span>
              <h5 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">Uzman Estetisyen Kadrosu</h5>
              <p className="text-xs text-foreground-400 leading-relaxed">Alanında deneyimli profesyoneller</p>
            </div>
            <div className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-customer-service-2-line text-primary-500 text-lg"></i>
              </span>
              <h5 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">7/24 Destek</h5>
              <p className="text-xs text-foreground-400 leading-relaxed">Her an yanınızdayız</p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center flex flex-col items-center gap-5">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200 text-xs md:text-sm font-medium text-accent-700">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-chat-smile-2-line text-accent-500 text-sm"></i>
            </span>
            Size Özel Danışmanlık
          </span>
          <h4 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
            <a href="https://wa.me/905433724578" target="_blank" rel="noopener noreferrer nofollow">
              Ücretsiz Danışmanlık Alın
            </a>
          </h4>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            Hangi işlemin size uygun olduğunu merak mı ediyorsunuz? Uzman ekibimiz size <strong>ücretsiz danışmanlık</strong> hizmeti sunuyor.
          </p>
          <a
            href="https://wa.me/905433724578?text=Merhaba%2C%20%C3%BCcretsiz%20dan%C4%B1%C5%9Fmanl%C4%B1k%20almak%20istiyorum."
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-fill text-base"></i>
            </span>
            Hemen WhatsApp ile Başlayın
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}